/**
 * Detect user's country from browser's IANA timezone.
 * Used as a fallback when server-side CF-IPCountry header is unavailable
 * (e.g. dev preview without Cloudflare proxy). In production with CF, the
 * server-side detection is preferred.
 *
 * Returns 2-letter ISO country code (best effort) or empty string.
 */

// Mapping of common IANA timezones → ISO-3166-1 alpha-2 country codes.
// Only timezones likely to be used by Vivek जी's customer base are listed.
const TZ_TO_COUNTRY = {
  // India
  'Asia/Kolkata': 'IN', 'Asia/Calcutta': 'IN',
  // UAE / Gulf
  'Asia/Dubai': 'AE', 'Asia/Muscat': 'OM', 'Asia/Qatar': 'QA',
  'Asia/Riyadh': 'SA', 'Asia/Bahrain': 'BH', 'Asia/Kuwait': 'KW',
  // South Asia diaspora
  'Asia/Karachi': 'PK', 'Asia/Dhaka': 'BD', 'Asia/Colombo': 'LK',
  'Asia/Kathmandu': 'NP',
  // East / Southeast Asia
  'Asia/Singapore': 'SG', 'Asia/Hong_Kong': 'HK', 'Asia/Kuala_Lumpur': 'MY',
  // UK / Europe
  'Europe/London': 'GB', 'Europe/Dublin': 'IE',
  'Europe/Paris': 'FR', 'Europe/Berlin': 'DE', 'Europe/Madrid': 'ES',
  'Europe/Rome': 'IT', 'Europe/Amsterdam': 'NL', 'Europe/Brussels': 'BE',
  'Europe/Vienna': 'AT', 'Europe/Lisbon': 'PT',
  // North America
  'America/New_York': 'US', 'America/Chicago': 'US', 'America/Denver': 'US',
  'America/Los_Angeles': 'US', 'America/Phoenix': 'US', 'America/Detroit': 'US',
  'America/Toronto': 'CA', 'America/Vancouver': 'CA',
  // Australia / NZ
  'Australia/Sydney': 'AU', 'Australia/Melbourne': 'AU', 'Australia/Perth': 'AU',
  'Pacific/Auckland': 'NZ',
};

export function detectCountryFromBrowser() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return TZ_TO_COUNTRY[tz] || '';
  } catch {
    return '';
  }
}
